import React, { useEffect } from "react";
import CircularProgress from "@mui/joy/CircularProgress";
import "./User_Profile.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faPencil } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { myAccount } from "../../../features/my_account/Slice";
import { IDS } from "../../../utils/IDS";
import { formatDate } from "../../../utils/common";

const User_Profile = ({ showClose }) => {


  const navigate = useNavigate();
  const dispatch = useDispatch();


  const user = useSelector((state) => state.myaccount.addMyaccount);
  const MAX_LEVEL = user?.level_count;

  const percentage = Math.round((Math.min(user?.level_id || 0, MAX_LEVEL) / MAX_LEVEL) * 100);


  useEffect(() => {
    dispatch(myAccount());
  }, [dispatch]);

  const infoData = [
    {
      label: "Sadhak ID",
      value: user?.sadhak_id || "--",
    },
    {
      label: "Phone Number",
      value: user?.contact_no || "--",
    },
    {
      label: "Country of Residence",
      value: user?.country_residence || "--",
    },
    {
      label: "Email",
      value: user?.email || "--",
    },

    {
      label: "Date of Birth",
      value: formatDate(user?.date_of_birth) || "--",
    },

    {
      label: "Address",
      value: user?.address || "--",
    },
  ];

  return (
    <section className="User_Profile">
      <div className="yellow_card">
        <div className="top_div">
          <div className="profile_pic_container">
            <div className="bg_img_div">
              <img
                src="/assets/images/profile/profile_form/profile_bg.png"
                className="bg_img"
              />
            </div>

            <div className="profile_img_div">
              <img
                src={user?.image ? IDS.IMG_URL + user?.image : "/assets/images/profile/profile_form/img1.png"}
                // src={user?.image || "--"}

                className="profile_img"
              />
            </div>

            <div className="progeress_holder">
              <CircularProgress
                size="lg"
                determinate
                value={user?.pfp_percentage}
                sx={{
                  "--CircularProgress-size": "90px",
                  "--CircularProgress-thickness": "6px",
                }}
              >
                <div className="percentage_holder">
                  <span className="percantage">{user?.pfp_percentage}%</span>
                </div>
              </CircularProgress>

            </div>
          </div>

          {showClose ? (
            <>
              <div
                className="close_icon_holder showClose"
                onClick={() => {
                  navigate("/profile");
                }}
              >
                <img src="/assets/images/profile/profile_form/close.png" className="close_img" />
              </div>
            </>
          ) : (
            <>
              <div
                className="edit_icon_holder"
                onClick={() => {
                  navigate("/edit-profile");
                }}
              >
                <FontAwesomeIcon icon={faPencil} className="edit_icon" />
              </div>

              <div
                className="setting_icon_holder"
                onClick={() => {
                  navigate("/settings/menu");
                }}
              >
                <FontAwesomeIcon icon={faGear} className="setting_icon" />
              </div>
            </>
          )}
        </div>

        <div className="profile_info_div">
          <div className="username_holder">
            <Common_Title_2 subText={user?.name || "Unknown"} />
          </div>

          <div className="main_info_holder_div">
            {infoData?.map((item) => {
              return (
                <div className="info_row">
                  <p className="label_text">{item?.label}</p>
                  <p className="value_text">{item?.value}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default User_Profile;
